<div class="option" #checkboxElement (click)="onContainerClick($event)">
    <div class="option__checkbox">
        <input class="option__checkbox__input"
        type="checkbox"
        [id]="optionId()?.toString() || optionId()"
        [value]="optionId()?.toString() || optionId()"
        [checked]="isCheckedState"
        (change)="toggleChecked()"
        (click)="$event.stopPropagation()"
        >
        <label [for]="optionId()?.toString() || optionId()" class="option__text" [ngClass]="{'checked': isCheckedState}">
            <p class="title">{{title()}}</p>
            <p class="subtitle {{subtitleColor()}}">{{price()}}</p>
        </label>
    </div>

    <div class="option__info" (click)="dialogOpen($event)">
        <img src="../assets/lib/icons/Icon_Info.svg" alt="Info">
    </div>
</div>

